import React from 'react'
import {nest, withProps} from 'recompose'
import {DelayRender} from 'views/Shared/components/DelayRender'
import {Queries} from 'views/Shared/enums/Queries'
import {useMenuHandler} from 'views/Shared/handlers/useMenuHandler'
import UnderDevelopment from '../../Shared/components/UnderDevelopment'

const ItemKeys = Object.freeze({
    DASHBOARD:       'dashboard',
    INCOME:          'income',
    OUTCOME:         'outcome',
    FUND_BUDGET:     'fund-budget',
    CHARITY_SUPPORT: 'charity-support',
    FINANCE_REPORT:  'finance-report',
})

const routeEntities = [
    { key: ItemKeys.DASHBOARD,       component: UnderDevelopment },
    { key: ItemKeys.INCOME,          component: UnderDevelopment },
    { key: ItemKeys.OUTCOME,         component: UnderDevelopment },
    { key: ItemKeys.FUND_BUDGET,     component: UnderDevelopment },
    { key: ItemKeys.CHARITY_SUPPORT, component: UnderDevelopment },
    { key: ItemKeys.FINANCE_REPORT,  component: UnderDevelopment },
].map(({ key, ...rest }) => ({ key, path: key, ...rest }))

const WorkspaceFinance = () => {
    const { Component } = useMenuHandler({
        routes: routeEntities,
        actionName: Queries.REL,
    })

    return (
        <div className="px-3 md:px-6">
            <Component />
        </div>
    )
}

export default nest(withProps({ lazy: true })(DelayRender), WorkspaceFinance)
